import API from 'services/api';

export const upsertReservationNote = ({
  reservationId,
  payload,
}: {
  reservationId: string | undefined;
  payload: string | undefined | null;
}) =>
  API.put(`/api/accommodation/calculations/${reservationId}/note`, payload, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
